<template>
    <img
        :src="require('../../assets/icons/soundcloud_icon.png')" alt="Soundcloud Icon"
        :width="width"
        :height="height"
    >
    <!-- currently disabled. icons that are outside of an autocomplete when that icon also exist in the autocomplete do not load properly.
    this is probably an issue with linearGradient -->
    <!-- <svg viewBox="0 0 447.727 447.727">
        <g>
            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="340.348" y1="311.8405"
                x2="340.348" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_1_);" d="M447.601,263.733c-1.785-25.984-23.127-46.862-49.142-48.123   c-9.942-0.482-19.306,1.84-27.373,6.24c-1.075-51.745-43.328-93.368-95.33-93.368c-13.755,0-26.82,2.923-38.627,8.168   c-2.541,1.129-4.16,3.673-4.16,6.454v169.067c0,3.906,3.167,7.073,7.073,7.073h155.837   C425.725,319.243,449.681,294.024,447.601,263.733z" />

            <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="219.1825" y1="311.8405"
                x2="219.1825" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_2_);" d="M219.182,139.431c-3.933,0-7.12,3.188-7.12,7.12v165.387c0,3.933,3.188,7.12,7.12,7.12   c3.932,0,7.121-3.188,7.121-7.12V146.551C226.303,142.619,223.114,139.431,219.182,139.431z" />

            <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="195.62" y1="311.8405"
                x2="195.62" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_3_);" d="M195.62,157.019c-3.933,0-7.12,3.188-7.12,7.12v147.799c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12V164.139C202.74,160.207,199.552,157.019,195.62,157.019z" />

            <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="172.057" y1="311.8405"
                x2="172.057" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_4_);" d="M172.057,165.033c-3.933,0-7.12,3.188-7.12,7.12v139.785c0,3.933,3.188,7.12,7.12,7.12   c3.933,0,7.12-3.188,7.12-7.12V172.153C179.178,168.22,175.99,165.033,172.057,165.033z" />

            <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="148.495" y1="311.8405"
                x2="148.495" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_5_);" d="M148.495,154.348c-3.933,0-7.12,3.188-7.12,7.12v150.47c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12v-150.47C155.615,157.536,152.427,154.348,148.495,154.348z" />

            <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="124.932" y1="311.8405"
                x2="124.932" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_6_);" d="M124.932,161.471c-3.933,0-7.12,3.188-7.12,7.12v143.347c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12V168.591C132.052,164.659,128.865,161.471,124.932,161.471z" />

            <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="101.37" y1="311.8405"
                x2="101.37" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_7_);" d="M101.37,175.718c-3.933,0-7.12,3.188-7.12,7.12v129.1c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12v-129.1C108.491,178.905,105.303,175.718,101.37,175.718z" />

            <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="77.808" y1="311.8405"
                x2="77.808" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_8_);" d="M77.808,203.32c-3.933,0-7.12,3.188-7.12,7.12v101.498c0,3.933,3.188,7.12,7.12,7.12   c3.933,0,7.12-3.188,7.12-7.12V210.44C84.928,206.508,81.74,203.32,77.808,203.32z" />

            <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="54.245" y1="311.8405"
                x2="54.245" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_9_);" d="M54.245,214.895c-3.933,0-7.12,3.188-7.12,7.12v89.923c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12v-89.923C61.365,218.083,58.178,214.895,54.245,214.895z" />

            <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="30.683" y1="311.8405"
                x2="30.683" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_10_);" d="M30.683,217.551c-3.933,0-7.12,3.188-7.12,7.12v84.611c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12v-84.611C37.803,220.739,34.615,217.551,30.683,217.551z" />

            <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="7.12" y1="311.8405"
                x2="7.12" y2="132.5705" gradientTransform="matrix(1 0 0 -1 0 450.0009)"
            >
                <stop offset="0" style="stop-color:#DE9329" />
                <stop offset="1" style="stop-color:#D64C1B" />
            </linearGradient>
            <path style="fill:url(#SVGID_11_);" d="M7.12,236.143c-3.933,0-7.12,3.188-7.12,7.12v48.756c0,3.933,3.188,7.12,7.12,7.12   s7.12-3.188,7.12-7.12v-48.756C14.24,239.33,11.053,236.143,7.12,236.143z" />
        </g>
    </svg> -->
</template>

<script>
export default {
    name: 'Soundcloud',
    props: {
        width: {
            type: [Number, String],
            default: 18
        },
        height: {
            type: [Number, String],
            default: 18
        }
    }
}
</script>
